import { EnumBasedItem, createEnumService } from "./base";

export enum ClassroomType {
  ON_SITE = "on_site",
  VIRTUAL_CLASSROOM = "virtual_classroom",
}

export class Classroom extends EnumBasedItem<ClassroomType> {}

const classroomService = createEnumService(ClassroomType, Classroom);
export default classroomService;
